import { render, staticRenderFns } from "./sales-metrics-component.vue?vue&type=template&id=ce6d3dd2&scoped=true"
import script from "./sales-metrics-component.vue?vue&type=script&lang=ts"
export * from "./sales-metrics-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6d3dd2",
  null
  
)

export default component.exports